<ng-container [formGroup]="group()">
  <ngx-monaco-editor [formControlName]="fieldName()"
                     [options]="options()"
                     [style.width]="'min(900px, 50vw)'"
                     [style.height]="'min(200px, 90vh)'"
                     appResizeHandle
                     [hitArea]="config.mobile() ? 48 : 20" />
</ng-container>
